module.exports = __webpack_public_path__ + "img/EMF-W-coral-LogoText-2022-colour.426d5dbd.png";